<template>
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
		stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
		<line x1="8" y1="21" x2="16" y2="21" />
		<line x1="12" y1="17" x2="12" y2="21" />
		<path d="M7 10l2-2 3 3 5-5" />
	</svg>
</template>

<script>
export default {
	name: "IconResults",
};
</script>
